@if ( !( auth.isAdmin || (auth.isInstituteUser && auth.user?.organisation ===
organisationId) )) {
<a class="edit" [routerLink]="viewLink" queryParamsHandling="merge">
  <un-icon type="eye" theme="outline"></un-icon>
  <span>{{ viewText }}</span>
</a>
} @else {
<a class="edit" [routerLink]="editLink">
  <un-icon type="form" theme="outline"></un-icon>
  <span i18n="@@edit">Edit</span>
</a>
<a class="clone" [routerLink]="cloneLink" [queryParams]="{ clone: itemId }">
  <un-icon type="copy" theme="outline"></un-icon>
  <span i18n="@@clone">Clone</span>
</a>
<a class="delete" (click)="delete.emit()"
  ><un-icon type="delete" theme="outline"></un-icon>
  @if (showDeleteText) {
  <span i18n="@@delete">Delete</span>
  }
</a>
}
